"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._GenericIndexScene = void 0;
/* eslint-disable no-underscore-dangle */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const react_router_redux_1 = require("react-router-redux");
const Card_1 = require("../../components/Card/Card");
const CardTitle_1 = require("../../components/CardTitle/CardTitle");
const DataTable_1 = require("../../components/DataTable/DataTable");
const IndexScene = (props) => {
    const { totalSize, onClick, onChangeLoopback, createLink, title, columns, defaultSorted, context, data, query, loading, } = props;
    let addLink = react_1.default.createElement("span", null);
    const { t } = react_i18next_1.useTranslation(context || 'GenericIndexScene');
    if (createLink) {
        addLink = (react_1.default.createElement(react_router_dom_1.Link, { className: "btn btn-primary float-right", to: createLink }, t('addNew')));
    }
    return (react_1.default.createElement(Card_1.Card, null,
        addLink,
        react_1.default.createElement(CardTitle_1.CardTitle, { lg: true }, title || t('title')),
        react_1.default.createElement(DataTable_1.DataTable, { data: data, totalSize: totalSize, context: context, keyField: "id", onChangeLoopback: onChangeLoopback, loading: loading, onClick: onClick, columns: columns, defaultSorted: defaultSorted || { dataField: 'id', order: 'asc' }, query: query })));
};
const WrappedGenericIndex = (props) => {
    const { data, count, fetch, onRowClick, loading, user, dataTableProps, context, createLink, title, } = props;
    let query;
    if (typeof dataTableProps.query === 'object')
        query = dataTableProps.query;
    else if (typeof dataTableProps.query === 'object')
        query = dataTableProps.query({ user });
    return (react_1.default.createElement(IndexScene, { columns: dataTableProps.columns, data: data, onClick: onRowClick, defaultSorted: dataTableProps.defaultSorted, loading: loading, context: context, totalSize: count, query: query, onChangeLoopback: fetch, createLink: createLink, title: title }));
};
const mapDispatchToProps = (dispatch, { redirectUrl, listAction }) => {
    const obj = {
        fetch: (filter) => dispatch(listAction(filter)),
    };
    if (redirectUrl) {
        obj.onRowClick = (_, row) => dispatch(react_router_redux_1.push(redirectUrl.replace(':id', `${row.id}`)));
    }
    return obj;
};
const mapStateToProps = (state, { reduxEntry, mapUser }) => {
    const map = {
        data: state[reduxEntry].list.data,
        count: state[reduxEntry].list.count,
        user: undefined,
        loading: state[reduxEntry].list.isFetchLoading || state[reduxEntry].list.isCountLoading,
    };
    if (mapUser)
        map.user = state.user.model.data;
    return map;
};
exports._GenericIndexScene = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(WrappedGenericIndex);
//# sourceMappingURL=_GenericIndexScene.js.map